export const Checkout_EN_Trans = {
  checkout_summary: "Checkout Summary",
  company_name: "Company Name:",
  membership_choice: "Membership choice:",
  total_price: "Total Price:",
  months: "month",
  years: "year",
  paypal: "PayPal",
  Submit: "Submit",
  credit_card: "Debit or Credit Card",
  Apply: "Apply",
  Applied: "Applied",
  enterCode: "Enter coupon code",
  msg: {
    invalid: "Coupon code is invalid or expired",
    used: "You have already used this coupon code",
    success: "Applied successfully",
    limit: "The coupon code has reached its maximum usage limit",
  },
  applied: "Coupon Applied!",
  oriPrice: "Original Amount:",
  discount: "Discount:",
  fPrice: "Final Amount:",
};
export const Checkout_DE_Trans = {
  checkout_summary: "Zusammenfassung der Bestellung",
  company_name: "Firmenname:",
  membership_choice: "Wahl der Mitgliedschaft:",
  total_price: "Gesamtpreis:",
  months: "monat",
  years: "jahr",
  paypal: "PayPal",
  Submit: "Absenden",
  credit_card: "Debit- oder Kreditkarte",
  Apply: "Anwenden",
  Applied: "Angewandt",
  enterCode: "Geben Sie den Gutscheincode ein",
  msg: {
    invalid: "Der Gutscheincode ist ungültig oder abgelaufen",
    used: "Sie haben diesen Gutscheincode bereits verwendet",
    success: "Erfolgreich angewendet",
    limit: "Der Gutscheincode hat sein maximales Verwendungslimit erreicht",
  },
  applied: "Gutschein eingelöst!",
  oriPrice: "Ursprünglicher Betrag:",
  discount: "Rabatt:",
  fPrice: "Endgültiger Betrag:",
};
